import DinamicaForm from '@/pages/monitoring/FormComponents/DinamicaForm.vue';
import { COMPANY_ID_MAP } from '../../../zabbix-shared/enums/companyId';
import BaseForm from '@/pages/monitoring/FormComponents/BaseForm.vue';

// Exemplo de importação de componente Vue para template customizado
// Importe o componente real conforme sua estrutura
// import DinamicaTemplateComponent from '@/components/templates/DinamicaTemplateComponent.vue';

export const templates = [
    {
        name: "Genérico",
        whatsapp: "{{PROBLEM}}: Iniciando verificação.",
        acknowledged: "",
        ticketTitle: "Genérico: {{HOST}}"
    },
]

export const dinamica = {
        name: "Genérico",
        title: "Genérico: {{HOST}}",
        message: "{{PROBLEM}}: Analisando tráfego dinâmico."
}


export const companyTemplateMap: { [key: number]: { template: typeof dinamica, component: typeof BaseForm } } = {
    [COMPANY_ID_MAP.DINAMICA]: {
        template: dinamica,
        component: BaseForm
    }
};

export const ticketMessage = "Horário do incidente: {{TIME}}. Iniciando tratativa para {{HOST}}, começando a tratar o problema {{PROBLEM}}";

export const defaultTemplate = templates[0];